"use strict";

define(["./selector-sizzle"], function () {
  "use strict";
});